module.exports = __webpack_public_path__ + "static/media/img3.928618ca.png";